<template>
  <div class="checkout-fallback-verify" :class="{ mobile: isMobile() }">
    <asset-v3 class="logo" dir="logos" name="logo.svg" />
    <CheckoutInfo
      v-if="hasCheckoutData && !showFeedback"
      @buttonCompleted="goToFeedback"/>
    <CheckoutApprovedFeedback
      v-else-if="isApproved && showFeedback && !showApprovedPage"
      @showApproved="showApproved"/>
    <CheckoutApprovedGrace v-else-if="isApproved && showApprovedPage && hasGracePeriod"/>
    <CheckoutApproved v-else-if="isApproved && showApprovedPage"/>
    <CheckoutDenied v-else-if="isDenied && showFeedback" class="content-wrapper"/>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import UtilMixin from '@/mixins/util';
import AssetV3 from '@/components/common/AssetV3.vue';
import CheckoutInfo from './CheckoutInfo.vue';
import CheckoutApprovedFeedback from './CheckoutApprovedFeedback.vue';
import CheckoutApproved from './CheckoutApproved.vue';
import CheckoutDenied from './CheckoutDenied.vue';
import CheckoutApprovedGrace from './CheckoutApprovedGrace.vue';

export default {
  name: 'checkout-fallback-verify',
  mixins: [UtilMixin],
  data: () => ({
  }),
  methods: {
    ...mapMutations('checkoutRedirect', [
      'setShowApprovedPage',
      'setShowFeedback',
    ]),
    showApproved() {
      this.setShowApprovedPage(true);
    },
    goToFeedback() {
      this.setShowFeedback(true);
    },
  },
  computed: {
    ...mapState('checkoutRedirect', [
      'showApprovedPage',
      'showFeedback',
      'hasGracePeriod',
    ]),
    ...mapGetters('checkoutRedirect', [
      'hasOptions',
      'hasCheckoutData',
      'isApproved',
      'isDenied',
    ]),
  },
  components: {
    AssetV3,
    CheckoutInfo,
    CheckoutApprovedFeedback,
    CheckoutApproved,
    CheckoutDenied,
    CheckoutApprovedGrace,
  },
};
</script>

<style lang="scss" scoped>

  .logo {
    margin: 25px 0px;

    &.mobile {
      height: 30px;
      margin: 20px 0px;
    }
  }
  .checkout-fallback-verify {
    height: 100%;
    &.mobile {
      position: absolute;
      width: calc(100% - 48px);
    }
  }
  .content-wrapper {
    &.mobile {
      position: absolute;
      height: calc(100% - 85px);
    }
  }
</style>
